import { Typography } from "@mui/material";
import React from "react";
import "./orderDetails2.css";
import "../../analytics/analytics.css";

export const TimelineDetails = ({ obj, isFirst }) => {

  return (
    <div className="timeline-details-single-component">
      <div className="timeline-details-icon">
        <img src={obj.icon}></img>
        <div
          className="connector-line"
          style={{
            display: isFirst ? "none" : "flex",
          }}
        ></div>
      </div>
      <div style={{ paddingBottom: "20px", overflowWrap: "anywhere" }}>
        <div className="timeline-details-title">
          <div className="detail-info">
            <Typography
              className="bodyB2MediumColored"
              style={{ paddingBottom: "4px" }}
            >
              {obj.title}
            </Typography>
            {/* {obj.info} */}
          </div>

          <div className="status-btn">{obj.btn != null ? obj.btn : <></>}</div>
        </div>
        <div className="timeline-subtitles">{obj.subtitle}</div>
      </div>
    </div>
  );
};
